// extracted by mini-css-extract-plugin
module.exports = {"container":"_3mhMABUwgqvJTzJtPFCFo-","item":"_3oN2oFv94bHh9FH0NIbX0l","dot":"IImCLp4vn-x-8gOqXwL0v","externalId":"hXDPxo72V4HIzFxkXVa-k"};